import cn from 'classnames';
import * as React from 'react';

import { sizes, themes, Text as Props } from './text.types';

const Text: React.FunctionComponent<React.PropsWithChildren<Props>> & {
  sizes: typeof sizes;
  themes: typeof themes;
} = ({
  children,
  className,
  elementName = 'div',
  italic,
  size = sizes.basic,
  theme = themes.normal,
  tight,
  ...restProps
}) =>
  React.createElement(
    elementName,
    {
      className: cn(
        'text',
        {
          'text--italic': italic,
          [`text--size-${size}`]: size ? sizes[size] : undefined,
          [`text--theme-${theme}`]: theme ? themes[theme] : undefined,
          'text--tight': tight,
        },
        className,
      ),
      ...restProps,
    },
    children,
  );

Text.sizes = sizes;
Text.themes = themes;

export default Text;
